import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-angle-up-down",
  "use": "arrow-angle-up-down-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"arrow-angle-up-down\"><path d=\"M4.345 5.654s-.674.55-.138 1.085c.536.536 1.086-.131 1.086-.138L8 3.896l2.712 2.712.01.009c.077.075.603.588 1.069.122.504-.504-.134-1.085-.134-1.082L7.999 2 4.345 5.654zm0 4.64s-.674-.55-.138-1.086 1.086.132 1.086.138L8 12.052l2.71-2.712.01-.01c.077-.075.603-.587 1.069-.122.504.504-.134 1.086-.134 1.082l-3.657 3.658-3.654-3.654z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol